import React from 'react'

import EditAccommodation from './EditAccommodation'
import EditAccommodationOld from './EditAccommodationOld'
import EditAttraction from './EditAttraction'
import EditCar from './EditCar'
import EditEvent from './EditEvent'
import EditFlight from './EditFlight'
import EditNote from './EditNote'
import EditRestaurantBar from './EditRestaurantBar'
import EditThingToDo from './EditThingToDo'
import EditTourAndCruises from './EditTourAndCruises'
import EditTransport from './EditTransport'

import { TripItem } from 'tripPlanner/types/tripItem'
import { assertUnreachable } from 'tripPlanner/utils'

interface Props {
  item: TripItem
}

function EditTripItem({ item }: Props) {
  switch (item.type) {
    case 'ACCOMMODATION':
      return <EditAccommodation item={item} />
    case 'HOTEL':
    case 'AIRBNB':
      return <EditAccommodationOld item={item} />
    case 'ATTRACTION':
      return <EditAttraction item={item} />
    case 'CAR_RENTAL':
      return <EditCar item={item} />
    case 'TOUR':
    case 'CRUISE':
      return <EditTourAndCruises item={item} />
    case 'FLIGHT':
      return <EditFlight item={item} />
    case 'NOTE':
      return <EditNote item={item} />
    case 'RESTAURANT_BAR':
      return <EditRestaurantBar item={item} />
    case 'OTHER_TRANSPORT':
    case 'TRAIN':
    case 'BUS':
    case 'FERRY':
      return <EditTransport item={item} />
    case 'EVENT':
      return <EditEvent item={item} />
    case 'EXPERIENCE':
      return <div></div>
    case 'THING_TO_DO':
      return <EditThingToDo item={item} />
    case 'ACCOMMODATION_RENTAL':
      return null
    default:
      return assertUnreachable(item)
  }
}

export default EditTripItem
